import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state:{
        //存放的键值对就是所要管理的状态
        name:'rootAdminVueX',
        // 存储token
        // Authorization: localStorage.getItem('Authorization') ? JSON.parse(localStorage.getItem('Authorization')): ''

    },
    mutations: {
        // 修改token，并将token存入localStorage
        changeLogin (state, data) {
            state.Authorization =data;
            localStorage.setItem('Authorization', data);           
        }
      }
})

export default store